import { type___locale___translations___collection } from '../../types/types.locale';

//	E X P O R T   L O C A L E

export const locale___ComDigitalMenuDishComponent: type___locale___translations___collection = {
	'delete': {
		de_de: 'Löschen',
		en_us: 'Delete',
		es_es: 'Eliminar',
		fr_fr: 'Supprimer',
		it_it: 'Elimina'
	},
};